<template>
  <div class="xps-upload directory" @click="uploadFile" @dragover="changeDropStat" @drop="dropFolders">
    <span class="iconfont icon-folder-upload-fill icon-directory upload-icon"></span>
    <p class="directory-text">点击/拖拽上传文件夹，会保留<em style="color:#409EFF;">文件路径</em></p>
    <p class="el-upload__tip">请选择项目保留文件名称（默认存储为hash名称）</p>
    <input type="file" name="file_data" id="upload" action="" multiple style="height:0" webkitdirectory>
  </div>
</template>

<script>
import { xpsApi, fileManageApi } from '@/api/index';
import { antiShake } from '@/common/utils/timerUtil.js';
import { showLoading, hideLoading } from '@/plugins/loading';
export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    isCompressed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filesList: [],
      isValidateFiles: true
    }
  },
  watch: {
    filesList (val) {
      if (val.length > 0) {
        antiShake(this.antiShakeUpload, 1000);
      }
    }
  },
  methods: {
    // 上传文件夹
    antiShakeUpload () {
      const e = { target: { files: this.filesList } };
      this.submitFormData(e);
    },
    // 资源上传
    uploadFile () {
      this.isValidateFiles = true;
      const dom = document.getElementById('upload');
      // 触发文件输入框点击事件
      dom.click();
      // 新增change事件
      dom.addEventListener('change', this.submitFormData);
    },
    // 提交formData
    async submitFormData (e) {
      showLoading();
      let files = e.target.files;
      // 如果不是压缩文件夹并且需要校验目录下的文件 
      if (this.isValidateFiles && !this.isCompressed) {
        let name = files[0].name; // 文件名称
        let str = name.substr(0, name.indexOf('/') + 1); // 当前文件夹名称
        // 查询当前文件夹是否存在文件
        return await this.checkCosExist(`${this.data.path || `/custom/day${this.data.day}/${this.formatFileName().name}`}${str}`, e);
      }
      let form = new FormData();
      // 添加传入参数
      for (let k in this.data) {
        form.append(k, this.data[k]);
      }
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const f1 = files[i];
          form.append('file', f1);
        }
      }
      try {
        if (this.isCompressed) {
          let { code, message, data } = await xpsApi.uploadDirectoryAndCompressed(form);
          if (code === 200) {
            this.$emit('handleSuccess', data);
          } else {
            this.$emit('handleError', message);
          }
        } else {
          let { code, message, data } = await xpsApi.uploadDirectory(form);
          if (code === 200) {
            this.$emit('handleSuccess', data);
          } else {
            this.$emit('handleError', message);
          }
        }
      } catch (e) {
        this.$emit('handleError', e);
        hideLoading();
        return null;
      }
      hideLoading();
      if (Array.isArray(files)) return;
      // 移除事件
      e.target.removeEventListener('change', this.submitFormData);
      // 重置
      e.target.value = '';
    },
    // 检查COS该目录是否存在文件
    async checkCosExist (path, e) {
      const res = await fileManageApi.getDirectoryFiles({ path });
      if (res && res.data && res.data.length > 0) {
        this.$confirm(`该路径的文件夹已存在，请确认是否需要覆盖原有文件夹`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.isValidateFiles = false;
          this.submitFormData(e);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      } else {
        this.isValidateFiles = false;
        this.submitFormData(e);
      }
      hideLoading();
    },
    changeDropStat (e) {
      e.stopPropagation();
      e.preventDefault();
    },
    // 拖拽文件夹，触发事件
    dropFolders (e) {
      e.stopPropagation();
      e.preventDefault();
      this.filesList = [];
      this.isValidateFiles = true;
      let items = e.dataTransfer.items;
      for (let i = 0; i < items.length; i++) {
        let item = items[i].webkitGetAsEntry()
        if (item) {
          this.checkFolders(item)
        }
      }
    },
    // 判断是否为文件夹
    checkFolders (item) {
      if (item.isDirectory) {
        this.traverseFileTree(item)
      } else {
        return this.$message.warning('仅支持上传文件夹哦~');
      }
    },
    traverseFileTree (item, path) {
      path = path || ''
      // 如果是文件
      if (item.isFile) {
        item.file((file) => {
          if (file.name !== '.DS_Store') {
            const name = path + file.name;
            // 修改文件名称
            this.filesList.push(new File([file], name));
          }
        })
      } else if (item.isDirectory) {//如果是文件夹
        let dirReader = item.createReader();
        let readEntries = dirReader.readEntries.bind(dirReader, (entries) => {
          if (!entries.length) return;
          entries = this.filterStore(entries)
          for (let i = 0; i < entries.length; i++) {
            entries[i].attr = item.attr;
            this.traverseFileTree(entries[i], path + item.name + '/');
          }
          readEntries();
        }, function (e) {
          console.log(e);
        })
        readEntries();
      }
    },
    // 过滤调Mac默认的.DS_Store文件
    filterStore (arr) {
      let entries = arr.filter(item => {
        return item.name !== '.DS_Store'
      })
      return entries
    },
    formatFileName () {
      const myDate = new Date();
      let year = myDate.getFullYear();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      month = month < 10 ? `0${month}` : month;
      day = day < 10 ? `0${day}` : day;
      return {
        name: `${year}/${month}/${day}/`,
        time: `${year}-${month}-${day}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.xps-upload {
  width: 100%;
  &.directory {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column wrap;
    height: 304px;
    border-radius: 6px;
    overflow: hidden;
    background-color: #f7f7f7;
    cursor: pointer;
    &:hover {
      // background-color: #f7f7f7;
      box-shadow: 0px 0px 10px rgb(233, 233, 233) inset;
    }
  }
  .upload-icon {
    // color: #c0c4cc;
    font-size: 130px !important;
    margin-top: 90px !important;
    &.icon-directory {
      margin-top: 0 !important;
      display: inline-block;
      color: #666;
    }
  }
  .directory-text {
    margin: 5px;
    font-size: 14px;
  }
}
</style>